import React, { Component } from "react";
import Empty from "../../image/empty.svg"
import axios from "axios";
import TutorDashMenu from "../../part/tutor_dash_menu";
import FooterDashboard from "../../part/footer.dashboard";
import Policy from "../../part/policy";
import DashSearchHeader from "../../part/header.search.dashboard";
import { Link } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { LuSearch } from "react-icons/lu";
import { LuListFilter } from "react-icons/lu";
import Navigate from "../../part/navigationComponent";
import LoadingError from "../../part/loading_error";


class TutorBlog extends Component {
    state = {
        menuCoverWidth: this.getInitialMenuCoverWidth(),
        blogs: [],
        searchBar: "",
        filter: "All Blog",
        isContactVisible: false,
        destination: "",
        trigger: 0,
        loading : false
    }
    getInitialMenuCoverWidth() {
        const windowWidth = window.innerWidth;
        if (windowWidth < 900) {
            return 0;
        } else if (windowWidth >= 900 && windowWidth < 1200) {
            return 60;
        } else {
            return 260;
        }
    }
    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.fetchBlogs();

        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            try {
                const user = JSON.parse(storedUser);
                if (user && user.role === 'student') {
                    window.location.href = '/dashboard';
                }
            } catch (error) {
                console.error("Error parsing user data:", error);
                localStorage.removeItem('user');
                localStorage.removeItem('accessToken');
                window.location.href = '/login';
            }
        } else {
            localStorage.removeItem('user');
            localStorage.removeItem('accessToken');
            window.location.href = '/login';
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
 
    handleResize = () => {
        const menuCover = document.querySelector('.dashboard .menu_cover');
        if (menuCover) {
            this.setState({ menuCoverWidth: menuCover.offsetWidth });
        }
        this.setState({ windowHeight: window.innerHeight - 60 });
    };

    fetchBlogs = async () => {
        this.setState({loading : true})
        const accessToken = localStorage.getItem("accessToken");
        try {
            const response = await axios.get("https://api.geoinfoacademy.com/api/blogs/", {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            this.setState({ blogs: response.data, loading: false });
            console.log("API Response:", response.data);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                console.warn("401 Unauthorized error detected. Clearing local storage and redirecting.");
                localStorage.removeItem("accessToken");
                localStorage.removeItem("user");
                window.location.href = "/";
            } else {
                console.error("Error fetching data:", error);
            }
            this.setState({loading : false})
        }
    };



    handleSearchChange = (e) => {
        this.setState({ searchBar: e.target.value });
    };


    blogFilter = () => {
        const { blogs, filter, searchBar } = this.state;
        let filteredList = blogs;

        // First: Filter by Category (GIS, Drone, etc.)
        if (filter !== "" && filter !== "All" && filter !== "All Blog") {
            filteredList = filteredList.filter(item => item.label === filter);
        }

        // Second: Filter by Search Query (Title, Narration, Label)
        if (searchBar.trim() !== "") {
            const query = searchBar.toLowerCase();
            filteredList = filteredList.filter(item => {
                return (
                    item.title?.toLowerCase().includes(query) ||
                    item.narration?.toLowerCase().includes(query) ||
                    item.label?.toLowerCase().includes(query)
                );
            });
        }

        return filteredList;
    };

    handleFilterChange = (value) => {
        this.setState({
            filter: value
        })
        // The blogFilter is called in render(), so no need to call it here, 
        // but calling setState will trigger a re-render where blogFilter is used.
    }


    handleDelete = async (list) => {
        const accessToken = localStorage.getItem("accessToken");
        this.setState({ loading: true })
        try {
            const response = await axios.delete(`https://api.geoinfoacademy.com/api/blogs/${list}/`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (response.status === 204 || response.status === 200) { // Check for successful delete status codes (204 No Content is common)
                console.log("Document deleted successfully:", list.id);
                this.fetchBlogs();
            } else {
                console.error("Error deleting document:", response.status, response.data);

            }
            this.setState({ loading: false })
        } catch (error) {
            console.error("Error deleting document:", error);
            alert("Error deleting document")
            this.setState({ loading: false })
        }
    };


    handleDropdown = () => {
        this.setState((prevState) => ({
            dropdown: !prevState.dropdown
        }));
    };


    handleClearFilter = () => {
        this.setState({
            searchBar: "",
            filter: "All Blog"
        })
    }

    handleRedirectEdit = (id) => {
        const { blogs } = this.state;

        // 1. Find the specific object by converting both IDs to Numbers
        const singleBlog = blogs.find(blog => Number(blog.id) === Number(id));

        // 2. Check if the blog exists before saving
        if (singleBlog) {
            // 3. Stringify and save the single object to localStorage
            localStorage.setItem("GeoacademyBlogPost", JSON.stringify(singleBlog));
            this.setState({
                destination: "/tutor_blog_edit",
                trigger : 1
            })
        } else {
            console.warn(`No blog found with ID: ${id}`);
        }
    }


render() {
    const { menuCoverWidth, dropdown, filter , destination , trigger, loading} = this.state;
    const filterdata = this.blogFilter()

    const bloglist = filterdata.length > 0 ? filterdata.map((info, index) => {
        return (
            <tr key={info.id}>
                <td className="sn">{index + 1}</td>
                <td>{info.title}</td>
                <td>{info.label}</td>
                <td className="delete" ><button onClick={() => this.handleDelete(info.id)} className="delete-button" style={{ backgroundColor: "red", color: "white", width: "150px", border: "red", borderRadius: "30px" }} >Delete Blog</button></td>
                <td className="delete" ><button onClick={() => this.handleRedirectEdit(info.id)} className="delete-button" style={{ backgroundColor: "green", color: "white", width: "150px", border: "green", borderRadius: "30px" }} >Edit Blog</button></td>
                <td className="delete" ><Link to={`/blog/${info.id}`}><button className="delete-button" style={{ backgroundColor: "rgb(0,0,0,0)", color: "rgba(0, 0, 0, 0.8)", width: "150px", border: "1px solid rgb(20,107,217)", borderRadius: "30px" }} >View Blog</button></Link></td>
            </tr>

        )
    }) : (
        <tr className="course_list_empty">
            <td>Loading ......</td>
        </tr>
    )

    return (
        <div className="dashboard">
            <DashSearchHeader onResize={this.handleResize} />
            <TutorDashMenu />
            <div className="dash_body" style={{ width: `calc(100% - ${menuCoverWidth}px - 10px)`, overflow: 'hidden' }}>
                <div className="course_head"  >
                    <h2> Blogs <button>Add Blog</button></h2>

                    <div className="filter_blog_cover" style={{ width: "90%", position: "relative", left: "5%" }}>

                        <div className="filter_blog_contain">
                            <p><LuListFilter /> Filter</p>
                            <div className="filter_drop_cover" ref={this.dropdownRef}>
                                <button onClick={this.handleDropdown}> {filter} <IoIosArrowDown /></button>
                                {dropdown &&
                                    <div className="filter_dropdown_contain" >
                                        <li onClick={() => this.handleFilterChange("All Blog")}>All Blog</li>
                                        <li onClick={() => this.handleFilterChange("GIS")}>GIS</li>
                                        <li onClick={() => this.handleFilterChange("Drone")}>Drone</li>
                                        <li onClick={() => this.handleFilterChange("Land Survey")}>Land Survey</li>
                                        <li onClick={() => this.handleFilterChange("Event")}>Event</li>
                                    </div>
                                }
                            </div>
                        </div>

                        <div className="filter_blog_contain">
                            <div className="filter_blog_search">
                                <input type="text" placeholder="search blog" value={this.state.searchBar} onChange={this.handleSearchChange} />
                                <button className="search"><LuSearch /> Search</button>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="course_body">
                    <div className="course_body_cover">

                        {filterdata.length > 1 ?
                            < div className="table">
                                <table className="librarytable">
                                    <thead>
                                        <tr>
                                            <th className="sn">S/N</th>
                                            <th className="course">Title</th>
                                            <th>Label</th>
                                            <th className="delete">Delete</th>
                                            <th className="delete">Edit</th>
                                            <th className="delete">View</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {bloglist}
                                    </tbody>
                                </table>
                            </div> :
                            <div className="course_list_empty">
                                <img src={Empty} alt="not avaialable" /><br />
                                <h5>No available course <br />with that specification.</h5>
                                <button onClick={this.handleClearFilter}>Reset Filter</button>
                            </div>
                        }
                    </div>
                </div>

                <FooterDashboard />
                <Policy />
            </div>
            <Navigate destination={destination} trigger={trigger}/>
            {loading ? <LoadingError /> : null}
        </div>
    )
}
}

export default TutorBlog